import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Fade } from '../Transition/index.js';

const ModalOverlay = _ref => {
  let {
    isOpen,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Fade, _extends({
    "data-test-id": "backdrop-overlay",
    isOpen: isOpen
  }, rest), children);
};

export { ModalOverlay };
